import React from 'react';
import PageMapper from '../helpers/pageMapper';
import { jsonReader } from '../helpers/tools';

class Sponsors extends React.Component{
    constructor(){
        super();
        this.state = {
            data: []
        }
    }

    async componentDidMount(){
        jsonReader("page_sponsors.json")
        .then(result => this.setState({
            data: result
        })
        )
    }

    render(){
        return(
            <PageMapper data={this.state.data}/>
        );
    }
}

export default Sponsors;